import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';
import { usePostMissionClearCardDataMutation } from 'store/missionClearCard';
import { updateMission } from 'store/missionClearCard';
import { MissionStatus } from 'store/progress';

// MissionClearCardを管理するためのカスタムフック
export function useMissionClearCard() {
  const dispatch = useDispatch();
  const missionClearCardState = useSelector((state: RootState) => state.missionClearCard);
  const { mission, isInitialize, missionStatus } = missionClearCardState;
  const [lastMissionStatus, setLastMissionStatus] = useState<MissionStatus | null>(null);

  const [
    postMissionClearCardData,
    { isLoading: isSubmittingMissionClearCard, error: submitMissionClearCardError },
  ] = usePostMissionClearCardDataMutation();

  const updateMissionState = (newMission: number) => {
    dispatch(updateMission(newMission));
  };

  const postMissionClearCard = async (mission: number) => {
    try {
      const result = await postMissionClearCardData({ mission }).unwrap();
      setLastMissionStatus(result);
    } catch (error) {
      console.error('Failed to post clear-card: ', error);
    }
  };

  return {
    mission,
    isInitialize,
    missionStatus,
    isSubmittingMissionClearCard,
    submitMissionClearCardError,
    updateMissionState,
    postMissionClearCard,
    lastMissionStatus,
  };
}
